import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveTo12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMoveTo12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm0 1h2v1h-2zm0 3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm0 1h2v1h-2zm-1 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm3 0h-2v1h2zM7 5a.5.5 0 0 0 1 0V3.627A3.5 3.5 0 0 1 9.5 6.5c0 1.19-.593 2.24-1.5 2.873V8a.5.5 0 1 0-1 0v3h3a.5.5 0 0 0 0-1H8.83a4.5 4.5 0 0 0 1.67-3.5A4.5 4.5 0 0 0 8.83 3H10a.5.5 0 0 0 0-1H7z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoveTo12);
